import { useEffect, useState } from 'react';
import { ReactComponent as LoadingIcon } from '../../../assets/icons/registerLoadingIcon.svg';
import styles from './register-loading.module.scss';

const LOADING_MESSAGES = [
  'Checking to see if you’re in our system…',
  'Aligning the stars...',
  'Getting things ready for you...',
  'Contacting the mothership ....',
];

const MESSAGE_INTERVAL = 5000;

export const RegisterLoading = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setMessageIndex((index) =>
        Math.min(index + 1, LOADING_MESSAGES.length - 1)
      );
    }, MESSAGE_INTERVAL);
    return () => clearInterval(id);
  }, []);

  return (
    <div className={styles['container']} role="status">
      <LoadingIcon className={styles['icon']} aria-hidden="true" />
      <p className={styles['message']}>{LOADING_MESSAGES[messageIndex]}</p>
    </div>
  );
};
